import { render, staticRenderFns } from "./aRmsApplyPrices.vue?vue&type=template&id=20788e83&scoped=true"
import script from "./aRmsApplyPrices.vue?vue&type=script&lang=js"
export * from "./aRmsApplyPrices.vue?vue&type=script&lang=js"
import style0 from "./aRmsApplyPrices.vue?vue&type=style&index=0&id=20788e83&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20788e83",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VIcon,VSpacer,VTextField,VTooltip})
